import React from 'react';
import { MapPin, Zap, Target, Users } from 'lucide-react';
import { whyChooseUs } from '../../data/mock';

const iconMap = {
  1: MapPin,
  2: Zap,
  3: Target,
  4: Users,
};

const WhyChooseUs = () => {
  return (
    <section id="why-us" className="bg-[#121212] py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <p className="text-[#00FFD1] text-sm font-medium tracking-wide uppercase mb-4">
              Why Choose Us
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-white leading-tight mb-6">
              Florida's Trusted Armed Security Partner
            </h2>
            <p className="text-lg text-white/70 leading-relaxed mb-8">
              With over 15 years of experience protecting Florida businesses and residents, 
              we've built a reputation for reliability, professionalism, and rapid response.
            </p>
            
            {/* Feature List */}
            <div className="space-y-6">
              {whyChooseUs.map((item) => {
                const Icon = iconMap[item.id];
                return (
                  <div key={item.id} className="flex items-start gap-4 group">
                    <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center border border-[#00FFD1]/30 group-hover:bg-[#00FFD1]/10 transition-all duration-400">
                      <Icon className="w-6 h-6 text-[#00FFD1]" />
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-white mb-1">
                        {item.title}
                      </h3>
                      <p className="text-white/60 leading-relaxed">
                        {item.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Content - Stats/Visual */}
          <div className="relative">
            <div className="bg-black border border-white/10 p-8 lg:p-12">
              <div className="grid grid-cols-2 gap-8">
                <div className="text-center p-6 border border-white/10">
                  <p className="text-4xl lg:text-5xl font-semibold text-[#00FFD1] mb-2">98%</p>
                  <p className="text-white/60">Client Retention</p>
                </div>
                <div className="text-center p-6 border border-white/10">
                  <p className="text-4xl lg:text-5xl font-semibold text-[#00FFD1] mb-2">15+</p>
                  <p className="text-white/60">Years Experience</p>
                </div>
                <div className="text-center p-6 border border-white/10">
                  <p className="text-4xl lg:text-5xl font-semibold text-[#00FFD1] mb-2">500+</p>
                  <p className="text-white/60">Active Officers</p>
                </div>
                <div className="text-center p-6 border border-white/10">
                  <p className="text-4xl lg:text-5xl font-semibold text-[#00FFD1] mb-2">0</p>
                  <p className="text-white/60">Major Incidents</p>
                </div>
              </div>
              
              <div className="mt-8 p-6 border border-[#00FFD1]/30 bg-[#00FFD1]/5">
                <p className="text-white text-center font-medium">
                  "Safety isn't just our business—it's our commitment to Florida."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
